// Import zavislosti
import $ from 'jquery';

// ReloadAjax modul
export const ReloadAjax = {
	reloadId: null,
	reloadElement: null,
	formElement: null,
	url: null,

	initialize(formId, urlParam, reloadId) {
		this.reloadId = reloadId;
		this.url = urlParam;
		this.formElement = $('#' + formId);
		this.reloadElement = $('#' + reloadId);
		this.changeInit();
	},

	changeInit() {
		this.formElement.find('input').on('change', () => {
			this.doReload();
		});
	},

	doReload() {
		const form = $(this.formElement).serializeArray();

		this.reloadElement.append("<div class='loader'></div>");

		const url = new URL(this.url);
		url.searchParams.set('offset', 0);

		$.post(url.toString(), form, (data) => {
			this.reloadElement.fadeOut('fast', () => {
				this.reloadElement.html(data);

				const mainUrl = new URL(window.location.href);
				mainUrl.searchParams.set('offset', 0);
				window.history.pushState("", "", mainUrl.toString());

				this.reloadElement.fadeIn('fast');
			});
		});
	},

	clearFilter() {
		// TODO: implementovat
	}
};

// ParamAjax modul
export const ParamAjax = {
	reloadId: null,
	reloadElement: null,
	formElement: null,
	url: null,

	clearFilter() {
		this.formElement.find("input[type='checkbox']").prop("checked", false);
		this.formElement.find("input[type='text']").val('');
		ReloadAjax.doReload();
		this.doReload();
	},

	initialize(formId, urlParam, reloadId) {
		this.reloadId = reloadId;
		this.url = urlParam;
		this.formElement = $('#' + formId);
		this.reloadElement = $('#' + reloadId);
		this.changeInit();

		$(".clear__filter").off("click.paramAjaxClear").on("click.paramAjaxClear", (event) => {
			event.preventDefault();
			this.clearFilter();
		});
	},

	changeInit() {
		this.formElement.find('input').on('change', () => {
			this.doReload();
		});
	},

	doReload() {
		const form = this.formElement.serialize();

		$.post(this.url, form, (data) => {
			this.reloadElement.fadeOut('fast', () => {
				this.reloadElement.html(data);
				this.changeInit();
				ReloadAjax.changeInit();
				this.reloadElement.fadeIn('fast');
			});
		});
	}
};

// Exportovat do window pro kompatibilitu se starym kodem (volitelne)
if (typeof window !== 'undefined') {
	window.ReloadAjax = ReloadAjax;
	window.ParamAjax = ParamAjax;
}